/* eslint-disable no-unused-vars */
import React from 'react'
import { Badge } from 'react-bootstrap'
import DateTime from '../../../helper/datetime'
// eslint-disable-next-line import/no-unresolved
import dataType from '../../../helper/constant/dataType'

const BalanceDetailHoldColumn = (actionFun, language) => ({
  key: 'id_hold',
  columns: [
    {
      name: 'ID Trx',
      selector: 'id_transaksi',
      sortable: true,
      type: dataType.INTEGER,
      showFilter: true,
    },
    {
      name: 'Tanggal Transaksi',
      selector: 'date_created',
      sortable: true,
      cell: (row) => DateTime.format(row.date_created, DateTime.FMT_DATE_TIME_YMDHMS3),
      type: dataType.DATERANGE,
      default: true,
      showFilter: true,
    },
    {
      name: 'Tanggal Settlement',
      selector: 'date_settlement',
      sortable: true,
      cell: (row) => DateTime.format(row.date_settlement, DateTime.FMT_DATE_TIME_YMDHMS3),
      type: dataType.DATERANGE,
      default: true,
      showFilter: true,
    },
    {
      name: 'Is Settle',
      selector: 'is_sent',
      sortable: false,
      cell: (row) => {
        let word
        let color
        switch (`${row.is_sent}`) {
          case '0':
            word = 'Belum'
            color = 'warning'
            break
          case '1':
            word = 'Sudah'
            color = 'success'
            break
          default:
            word = 'Process'
            color = 'info'
            break
        }
        return <Badge variant={color}>{word}</Badge>
      },
      showFilter: true,
      type: dataType.ENUM,
      default_value: [
        {
          id: '1',
          name: 'Sudah',
        },
        {
          id: '0',
          name: 'Belum',
        },
      ],
    },
  ],
})

export default BalanceDetailHoldColumn
